// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1sgv8","loaderOuter":"PageOverlayLoader_loaderOuter__3oicc"};